import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { RootState } from '..';

export interface IMapSlice {
    image: string;
}

const initialState: IReduxState<IMapSlice> = {
    status: EReduxState.initialState,
    data: { image: '' },
};

export const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        cleanMap: state => {
            state.status = EReduxState.initialState;
            state.data = { image: '' };
        },
        setMap: (state, action: PayloadAction<IMapSlice>) => {
            state.status = EReduxState.fulfilled;
            state.data!.image = action.payload.image;
        },
    },
});

export const { cleanMap, setMap } = mapSlice.actions;

export const selectMap = (state: RootState) => state.map;

export default mapSlice.reducer;
